//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {GetContentById} from 'service/cmssg'
import { formatStandardTitle } from '@/utils/standard'
import { readCookie } from 'teld-web-component/lib/method'
 export default {
    data () {
        return {
            hiCode:this.$route.query.hiCode || "",
            title:"",
            content:"",
            Show:""
        }
    },
    components: {
    },
    watch:{
    '$route'(to,from){
        if(to.path=='/ActivityPage3'){
           this.init(to.query.hiCode);
        }
    }},
    mounted () {
        formatStandardTitle()
        this.init();
    },
    methods: {
        init:function (v) {
            var _this = this;
            if(v){
                _this.hiCode=v
            }
            let TELDAppID = _this.$route.query.TELDAPPID || readCookie("TELDAppID") || "";
            GetContentById({"hiCode":_this.hiCode, "TELDAppID": TELDAppID},function (res) {
                if(res.state=="1"){
                    let data = res.data;
                    if (window.navigator.userAgent.indexOf('TeldIosWebView') !== -1){
                        window.$teld.setWebviewTitle(data.Title);
                    }
                    else if (window.navigator.userAgent.indexOf('TeldAndroidWebView') !== -1){
                        window.$teld.setWebviewTitle(data.Title);
                    }
                    else {
                        document.title=data.Title
                    }

                    if(data.Title=="地锁状态说明"){
                        _this.Show = false;
                    }else {
                        _this.Show = true;
                    }
                    _this.title = data.Title;
                    _this.content = data.Content;
                }else {
                    console.log(res.errmsg);
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/module/PicActivity/ActivityPage3.vue